import styled from "styled-components";
import {Colors} from "@shared/styles/colors";
import {ButtonStyleProps} from "@shared/ui/types/button";

const NotFoundPageLayout = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    flex-direction: column;

`;
const NotFoundContainer = styled.div`
    width: 400px;
    height: 280px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${Colors.defaultContainerColor};
    align-items: center;
    border-radius: 20px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
`

const NotFoundIcon = styled.img`
    width: 80px;
`

const TitleText = styled.div`
    font-size: 24px;
    font-family: Pretendard-Bold, emoji;
    color: ${Colors.boldTextColor};
`

const ContentText = styled.div`
    font-size: 20px;
    font-family: Pretendard-Medium, emoji;
    color: ${Colors.boldTextColor};
`

const OkButton = styled.div<ButtonStyleProps>`
    border-radius: 10px;
    width: 200px;
    height: 44px;
    background-color: ${(props) => `${props.$backgroundColor}`};
    color: ${(props) => `${props.$buttonTextColor}`};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-3px);
    }

    &:active {
        transform: translateY(0px);
    }
`;

export const s = {
    NotFoundPageLayout,

    NotFoundContainer,
    NotFoundIcon,
    TitleText,
    ContentText,
    OkButton
}
